import { render } from "./ModalWaitingList.vue?vue&type=template&id=2a057604"
import script from "./ModalWaitingList.vue?vue&type=script&lang=js"
export * from "./ModalWaitingList.vue?vue&type=script&lang=js"

import "./ModalWaitingList.vue?vue&type=style&index=0&id=2a057604&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__